import { render, staticRenderFns } from "./ControlOption.vue?vue&type=template&id=641fc90b"
import script from "./ControlOption.vue?vue&type=script&lang=js"
export * from "./ControlOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports